import { HMSMessage } from "@100mslive/react-sdk";
import { useAuth } from "app/context/auth-context";
import { Roles } from "app/types";
import classNames from "classnames";
import ReactTimeAgo from 'react-time-ago'

export const ChatMessage = ({ message }: { message: HMSMessage }) => {
    const { user } = useAuth();
    const isCurrentUser = message.senderUserId
        ? message.senderUserId === user?.id.toString()
        : ((user?.roles?.includes(Roles.Recruiter) && message.senderRole === 'interviewer') || (user?.roles?.includes(Roles.Applicant) && message.senderRole !== 'interviewer')); // fallback logic
    return (
        <div className={classNames("d-flex mb-3", { 'justify-content-start': !isCurrentUser }, { 'justify-content-end': isCurrentUser })}>
            <div
                className="chat-bubble"
                style={{
                    maxWidth: '75%',
                    padding: '10px 15px',
                    borderRadius: '18px',
                    backgroundColor: isCurrentUser ? '#007bff' : '#f8f9fa',
                    color: isCurrentUser ? 'white' : '#212529',
                    wordWrap: 'break-word',
                    boxShadow: '0 1px 2px rgba(0,0,0,0.1)'
                }}
            >
                <div style={{ fontWeight: 600, marginBottom: '4px', fontSize: '0.85rem' }}>
                    {isCurrentUser ? 'You' : message.senderName}
                </div>
                <div style={{ marginBottom: '4px', lineHeight: '1.4' }}>{message.message}</div>
                <div style={{ fontSize: '0.75rem', opacity: 0.7 }}>
                    <ReactTimeAgo date={message.time ? new Date(message.time).getTime() : Date.now()} locale="en-US" />
                </div>
            </div>
        </div>
    );
}
